<ng-select
  class="app-dropdown"
  [class.app-dropdown-centered]="true"
  [class.app-dropdown-custom-menu-width]="hasCustomMenuWidth()"
  [class.app-dropdown-borderless]="!hasBorder()"
  [class.app-dropdown-hover-highlight]="hasHoverBackgroundColor()"
  [class.app-dropdown-hover-arrow-color]="hasHoverArrowColor()"
  [class.app-dropdown-option-hover-color]="hasOptionHoverBackgroundColor()"
  [class.app-dropdown-arrow-on-hover]="showArrowOnHover()"
  [class.app-dropdown-has-null-text]="hasNullText()"
  [class.app-dropdown-has-selection]="hasSelection()"
  [style.--app-dropdown-menu-width]="dropdownMenuWidth()"
  [style.--app-dropdown-border-color]="borderColor()"
  [style.--app-dropdown-hover-bg-color]="hoverBackgroundColor()"
  [style.--app-dropdown-hover-arrow-color]="hoverArrowColor()"
  [style.--app-dropdown-option-hover-bg-color]="optionHoverBackgroundColor()"
  [items]="items()"
  [bindLabel]="bindLabel()"
  [bindValue]="bindValue()"
  [labelForId]="labelForId()"
  [placeholder]="displayPlaceholder()"
  [dropdownPosition]="dropdownPosition()"
  [clearable]="clearable()"
  [searchable]="searchable()"
  [multiple]="multiple()"
  [loading]="loading()"
  [searchFn]="searchFn()"
  [notFoundText]="notFoundText()"
  [disabled]="disabledState()"
  [ngModel]="value()"
  (search)="handleSearch($event)"
  (ngModelChange)="handleModelChange($event)"
  (blur)="handleBlur()"
>
  @if (templateLabel() || hasLabelIcon() || hasItemIcon()) {
    <ng-template ng-label-tmp let-item="item">
      <span class="app-dropdown__label">
        @if (resolveItemIconPath(item); as itemIcon) {
          <app-icon class="app-dropdown__label-icon" [icon]="itemIcon" [color]="itemIconColor()" [width]="20" [height]="20" />
        }
        @else if (hasLabelIcon()) {
          <app-icon class="app-dropdown__label-icon" [icon]="labelIconPath()!" [color]="labelIconColor()" [width]="20" [height]="20" />
        }
        <span
          [style.font-weight]="labelFontWeight()"
          [style.color]="labelColor()"
          [style.font-size]="labelFontSize()"
        >{{ renderLabel(item) }}</span>
      </span>
    </ng-template>
  }
  @else {
    <ng-content select="ng-template[ng-label-tmp]"></ng-content>
  }

  @if (templateOption() || hasItemIcon()) {
    <ng-template ng-option-tmp let-item="item">
      <span class="app-dropdown__option">
        @if (resolveItemIconPath(item); as itemIcon) {
          <app-icon class="app-dropdown__option-icon" [icon]="itemIcon" [color]="itemIconColor()" [width]="20" [height]="20" />
        }
        <span>{{ templateOption() ? renderTemplateOption(item) : renderLabel(item) }}</span>
      </span>
    </ng-template>
  }
  @else {
    <ng-content select="ng-template[ng-option-tmp]"></ng-content>
  }
</ng-select>
